// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LpMO","col":"styles_col__10D4G"};